import { ProgressStatuses } from "../../tasks-wizard/models/progress-statuses";

export class JobProgressStatus {
    jobId: string;
    candidateAccountId: string;
    status: ProgressStatuses;

    public static parse(jsonData): JobProgressStatus {
        let progress = new JobProgressStatus();
        progress = Object.assign(progress, jsonData);
        return progress;
    }
}